import type { Permission } from '@cobliteam/permissions';

const PathAssociationPermissions: Record<string, Permission> = {
  UPDATE_DRIVER_FACE_CLUSTER: 'update:driver-face-cluster',
};

export default PathAssociationPermissions;
